<div class="cf-page" *ngIf="configLoaded && form">

  <form [formGroup]="form" (ngSubmit)="submitForm()" class="cf-form">

    <!-- Admin-only "Company test" switch, rendered in the header rather than inside a card
         (Figma node 1653:10622). The Company card excludes this field so it is not drawn twice.
         Positioned absolutely against .cf-form (see company-form.component.scss) so it lands on
         the same visual line as the "New company"/"Edit company" title, which is rendered by the
         shared title bar OUTSIDE this component — same technique as .pod-is-test-checkbox in the
         Purchase Order form. -->
    <div class="cf-header-switch" *ngIf="isAdmin && testCompanyControlName">
      <input
        class="rp-switch"
        id="companytest"
        type="checkbox"
        [formControlName]="testCompanyControlName"
      >
      <label for="companytest">{{ LABELS.TEST_SWITCH }}</label>
    </div>

    <div class="cf-page__head">
      <span class="cf-page__legend">{{ LABELS.REQUIRED_LEGEND }}</span>
    </div>

    <div class="cf-sections">
      <div class="cf-saving-overlay" *ngIf="isSaving || configReloading"></div>

      <ng-container *ngFor="let section of sections; trackBy: trackBySectionKey">
        <ng-container *ngIf="isSectionRendered(section)" [ngSwitch]="section.kind">

          <app-company-files-card
            *ngSwitchCase="SECTION_KIND.FILES"
            [section]="section"
            [form]="form"
            [submitted]="submitted"
            [required]="isFileSectionRequired(section)"
            [companyId]="companyId"
            [documentConfig]="documentConfigFor(section)"
            [strictMode]="documentsStrictMode"
          ></app-company-files-card>

          <app-agency-rebates-card
            *ngSwitchCase="SECTION_KIND.REBATES"
            [section]="section"
            [form]="form"
            [submitted]="submitted"
          ></app-agency-rebates-card>

          <app-company-form-section
            *ngSwitchDefault
            [section]="section"
            [form]="form"
            [states]="states"
            [submitted]="submitted"
            [sources]="sources"
            [resolvers]="resolvers"
            [excludedControlNames]="excludedControlNames"
            [country]="country"
            [isInternationalCompany]="isInternationalCompany"
            (underInputClick)="onUnderInputClick($event)"
            (editOptionClick)="onEditOptionClick($event)"
          ></app-company-form-section>

        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="footerReady">
      <!-- Edit from the detail (already submitted company): Cancel + Save changes -->
      <div class="cf-footer" *ngIf="mode === MODE.EDIT && !isDraftEdit">
        <button
          type="button"
          class="rp-button rp-outlined rp-primary"
          [disabled]="isSaving"
          (click)="cancelEdit()"
        >
          {{ LABELS.CANCEL }}
        </button>

        <button
          type="button"
          class="rp-button rp-filled rp-primary"
          [disabled]="!canSave"
          (click)="saveChanges()"
        >
          {{ isSaving ? LABELS.SAVING : LABELS.SAVE_CHANGES }}
        </button>
      </div>

      <!-- Create, or edit a Draft (from the list): Save draft + Submit for verification -->
      <div class="cf-footer" *ngIf="mode !== MODE.EDIT || isDraftEdit">
        <button
          type="button"
          class="rp-button rp-outlined rp-primary"
          [disabled]="!canSave"
          (click)="saveDraft()"
        >
          {{ isSaving ? LABELS.SAVING : LABELS.SAVE_DRAFT }}
        </button>

        <button
          type="submit"
          class="rp-button rp-filled rp-primary"
          [disabled]="!canSave"
        >
          {{ isSaving ? LABELS.SAVING : LABELS.SUBMIT }}
        </button>
      </div>
    </ng-container>

  </form>

</div>
